// Uploaded documents never receive the application's origin or network access.
export const DOCUMENT_SANDBOX = '';

export const isolateHtml = (html) => `<!doctype html><html><head><meta charset="utf-8"><meta http-equiv="Content-Security-Policy" content="default-src 'none'; style-src 'unsafe-inline'; img-src data: blob:; font-src data:; base-uri 'none'; form-action 'none'"></head><body>${html}</body></html>`;

export const htmlPreviewDocument = (html) => {
  const srcdoc = isolateHtml(html)
    .replace(/&/g, '&amp;').replace(/"/g, '&quot;')
    .replace(/</g, '&lt;').replace(/>/g, '&gt;');
  return `<!doctype html><html><head><meta charset="utf-8"><meta http-equiv="Content-Security-Policy" content="default-src 'none'; frame-src about:; style-src 'unsafe-inline'; base-uri 'none'; form-action 'none'"><title>Document</title><style>html,body,iframe{width:100%;height:100%;margin:0;border:0}</style></head><body><iframe sandbox="" referrerpolicy="no-referrer" srcdoc="${srcdoc}"></iframe></body></html>`;
};
